import React from 'react';

import { IPopularPostCard, PopularPostCard } from '../Card/Popular';

import style from './PopularPosts.scss';

interface IProps {
  posts: {
    node: IPopularPostCard;
  }[];
}

export const PopularPosts = ({ posts }: IProps) => {
  return (
    <section className={style.default}>
      {posts.map(({ node }, index) => (
        <PopularPostCard key={index} post={node} />
      ))}
    </section>
  );
};
